import coninImage from "../assets/img/conin.jpg";
import ingenesImage from "../assets/img/ingenes.jpg";
import surrogacyImage from "../assets/img/surrogacy-ingenes.jpg";

export interface IProject {
  title: string;
  subtitle?: string;
  image: string;
  description: string;
  techStack: Array<string>;
  isFirstItem?: boolean;
  urlDeploy?: string;
  urlGithub?: string;
}

export const englishProjects: Array<IProject> = [
  {
    title: "Ingenes",
    subtitle: "More & Surrogacy",
    image: surrogacyImage,
    description:
      "Scheduling system for two new services, More and Surrogacy, designed to meet international standards and reach new markets like Europe. This involved adapting workflows and aligning with different cultural and regulatory requirements, expanding the company's global presence",
    techStack: [
      "React",
      "Redux",
      "Node",
      "Javascript",
      "Typescript",
      "Nest",
      "TypeORM",
      "MySQL",
      "MongoDB",
      "Docker",
      "Git",
      "SCRUM",
    ],
    urlDeploy: "https://www.ingenes.com/en/our-services/surrogacy/",
  },
  {
    title: "Ingenes",
    subtitle: "Fertility",
    image: ingenesImage,
    description:
      "Scheduling system that allows users to manage their medical appointments or get assistance from the contact center. This system was successfully launched in 21 branches across Mexico and the United States, making medical services more accessible to users",
    techStack: [
      "React",
      "Redux",
      "Node",
      "Javascript",
      "Express",
      "Sequelize",
      "MySQL",
      "MongoDB",
      "Docker",
      "Git",
      "SCRUM",
    ],
    urlDeploy: "https://www.ingenes.com/en/",
  },
  {
    title: "CONIN SMT",
    image: coninImage,
    description:
      "High-impact social project aimed at combating child malnutrition in Argentina. It allows users to make donations through Mercado Pago, in order to provide food and necessary resources to improve the health and well-being of affected children.",
    techStack: [
      "Javascript",
      "React",
      "Firebase",
      "NodeJS",
      "Express",
      "SCRUM",
      "Git",
      "Mercado Pago",
    ],
    urlDeploy: "https://embajadores-conin.vercel.app/",
  },
];

export const spanishProjects: Array<IProject> = [
  {
    title: "Ingenes",
    subtitle: "More y Subrogado",
    image: surrogacyImage,
    description:
      "Aplicacion web de agendamiento para dos nuevos servicios, More y Gestación Subrogada, diseñado para llegar a nuevos mercados como Europa. Esto implicó adaptar los flujos de trabajo, automatizar procesos y adaptarse a las diferentes necesidades culturales, ampliando la presencia global de la empresa.",
    techStack: [
      "React",
      "Redux",
      "Node",
      "Javascript",
      "Typescript",
      "Nest",
      "TypeORM",
      "MySQL",
      "MongoDB",
      "Docker",
      "Git",
      "SCRUM",
    ],
    urlDeploy: "https://www.ingenes.com/en/our-services/surrogacy/",
  },
  {
    title: "Ingenes",
    subtitle: "Fertilidad",
    image: ingenesImage,
    description:
      "Sistema de agendamiento que permite a los usuarios gestionar sus citas médicas o recibir asistencia del centro de contacto. Este sistema se implementó con éxito en 21 sucursales en México y Estados Unidos, facilitando el acceso a los servicios médicos.",
    techStack: [
      "React",
      "Redux",
      "Node",
      "Javascript",
      "Express",
      "Sequelize",
      "MySQL",
      "MongoDB",
      "Docker",
      "Git",
      "SCRUM",
    ],
    urlDeploy: "https://www.ingenes.com/en/",
  },
  {
    title: "CONIN SMT",
    image: coninImage,
    description:
      "Proyecto social de alto impacto que combate la desnutrición infantil en Argentina. Permite a los usuarios realizar donaciones a través de Mercado Pago para proporcionar alimentos y los recursos necesarios para mejorar la salud y el bienestar de los niños afectados.",
    techStack: [
      "Javascript",
      "React",
      "Firebase",
      "NodeJS",
      "PostgreSQL",
      "Express",
      "SCRUM",
      "Git",
      "Mercado Pago",
    ],
    urlDeploy: "https://embajadores-conin.vercel.app/",
  },
];
